import React, { useEffect } from "react"
import PixelController from "../controllers/PixelController"
import { getLocalItem, setLocalItem, removeLocalItem } from "../helpers/StorageTools"

// Fonte única de verdade de "pixel inicializado nesta sessão". Consumir via isPixelActive()
// nos gates de evento — o localStorage sozinho persiste mesmo após a integração ser removida
// ou o chunk do react-facebook-pixel falhar, e divergiria do estado real do fbq.
let activePixel = null
export const isPixelActive = () => !!activePixel

// Dispara eventos do Pixel sem incluir a lib no bundle principal (import dinâmico,
// mesmo padrão do initPixel abaixo — o track só roda se o pixel já foi inicializado)
// eventId (opcional) habilita a deduplicação com o evento server-side da Conversion API,
// que envia o mesmo event_id — sem ele o Meta contaria browser + servidor como duas conversões.
export const trackPixelEvent = (event, data = {}, eventId = null) => {
  import("react-facebook-pixel")
    .then((x) => x.default)
    .then((ReactPixel) => (eventId ? ReactPixel.fbq("track", event, data, { eventID: eventId }) : ReactPixel.track(event, data)))
    .catch(() => console.info("Facebook Pixel indisponível, evento não enviado:", event))
}

const FacebookPixelManager = ({ companyId, activePixelId, setActivePixelId }) => {
  const pixelInitializedRef = React.useRef(null)

  useEffect(() => {
    if (activePixelId.companies.includes(companyId)) {
      console.info("PIXEL ATIVO PARA:", { companyId })
      return
    }
    getPixelIntegation().then()
    return () => {
      console.info("Desmontando Facebook Pixel para:", companyId)
    }
  }, [])

  const getPixelIntegation = async () => {
    // Verificando dado local para inicialização mais rápida
    const pixelIdLocal = getLocalItem("pixelId")
    if (!!pixelIdLocal) {
      await initPixel(pixelIdLocal)
    }
    // Verificando os dados no banco de dados para ver se houve alteração
    const responsePixelId = await PixelController.getPixelId()
    if (responsePixelId.status === 200) {
      const pixelId = responsePixelId?.data?.pixel_id
      if (!pixelId || pixelId.length === 0) {
        // Pixel removido/desativado no banco: invalida o cache local para os gates de evento pararem de disparar
        removeLocalItem("pixelId")
        activePixel = null
      } else if (activePixelId?.pixelId !== pixelId && pixelId !== pixelIdLocal && pixelInitializedRef.current !== pixelId) {
        await initPixel(pixelId)
      } else {
        console.info("PIXEL ATIVO PARA:", companyId)
      }
    }
  }

  const initPixel = async (pixelId) => {
    await import("react-facebook-pixel")
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.init(pixelId)
        ReactPixel.pageView()
        activePixel = pixelId
        setActivePixelId({ companies: [...activePixelId.companies, companyId], pixelId })
        setLocalItem("pixelId", pixelId)
        pixelInitializedRef.current = pixelId
        console.info("NOVO PIXEL INICIALIZADO:", companyId)
      })
      // Sem o catch, uma falha no chunk abortaria o getPixelIntegation e deixaria rejection sem handler
      .catch(() => console.info("Falha ao inicializar o Facebook Pixel:", companyId))
  }

  return null
}

export default FacebookPixelManager
